module.exports = __webpack_public_path__ + "static/media/IMG-20230508-WA0175.c4a0e640.jpg";